// src/data/languages/peul/categories/sentencesgap.ts

import { RevisionSentenceCollection } from '../../../../types/types';

// Collection de phrases pour la révision en peul (pulaar)
export const sentencesgap: RevisionSentenceCollection = {
  // Pronoms sujets
  "miin": [
    { original: "Miin, mi yahan", french: "Moi, je vais", english: "As for me, I go" },
    { original: "Miin, mi janngi", french: "Moi, j'étudie", english: "As for me, I study" },
    { original: "Miin, mi ñaami", french: "Moi, je mange", english: "As for me, I eat" }
  ],
  "aan": [
    { original: "Aan, a yahan", french: "Toi, tu vas", english: "As for you, you go" },
    { original: "Aan, a janngi", french: "Toi, tu étudies", english: "As for you, you study" },
    { original: "Aan, a ñaami", french: "Toi, tu manges", english: "As for you, you eat" }
  ],
  "kanko": [
    { original: "Kanko, o yahan", french: "Lui/Elle, il/elle va", english: "As for him/her, he/she goes" },
    { original: "Kanko, o janngi", french: "Lui/Elle, il/elle étudie", english: "As for him/her, he/she studies" },
    { original: "Kanko, o ñaami", french: "Lui/Elle, il/elle mange", english: "As for him/her, he/she eats" }
  ],
  "minen": [
    { original: "Minen, min njahan", french: "Nous, nous allons", english: "As for us, we go" },
    { original: "Minen, min njanngi", french: "Nous, nous étudions", english: "As for us, we study" },
    { original: "Minen, min ñaami", french: "Nous, nous mangeons", english: "As for us, we eat" }
  ],
  "onon": [
    { original: "Onon, on njahan", french: "Vous, vous allez", english: "As for you (all), you go" },
    { original: "Onon, on njanngi", french: "Vous, vous étudiez", english: "As for you (all), you study" },
    { original: "Onon, on ñaami", french: "Vous, vous mangez", english: "As for you (all), you eat" }
  ],
  "kamɓe": [
    { original: "Kamɓe, ɓe njahan", french: "Eux/Elles, ils/elles vont", english: "As for them, they go" },
    { original: "Kamɓe, ɓe njanngi", french: "Eux/Elles, ils/elles étudient", english: "As for them, they study" },
    { original: "Kamɓe, ɓe ñaami", french: "Eux/Elles, ils/elles mangent", english: "As for them, they eat" }
  ],

  // Conjugaison présent
  "miɗo_yaha": [
    { original: "Miɗo yaha to luumo", french: "Je suis en train d'aller au marché", english: "I am going to the market" },
    { original: "Miɗo yaha to galle", french: "Je suis en train d'aller à la maison", english: "I am going home" },
    { original: "Miɗo yaha to maayo", french: "Je suis en train d'aller à la rivière", english: "I am going to the river" }
  ],
  "aɗa_yaha": [
    { original: "Aɗa yaha to lekkol", french: "Tu es en train d'aller à l'école", english: "You are going to school" },
    { original: "Aɗa yaha to luumo", french: "Tu es en train d'aller au marché", english: "You are going to the market" },
    { original: "Aɗa yaha to galle", french: "Tu es en train d'aller à la maison", english: "You are going home" }
  ],
  "omo_yaha": [
    { original: "Omo yaha to galle", french: "Il/Elle est en train d'aller à la maison", english: "He/She is going home" },
    { original: "Omo yaha to lekkol", french: "Il/Elle est en train d'aller à l'école", english: "He/She is going to school" },
    { original: "Omo yaha to luumo", french: "Il/Elle est en train d'aller au marché", english: "He/She is going to the market" }
  ],

  // Conjugaison passé
  "mi_yahii": [
    { original: "Mi yahii to luumo", french: "Je suis allé(e) au marché", english: "I went to the market" },
    { original: "Mi yahii to galle", french: "Je suis allé(e) à la maison", english: "I went home" },
    { original: "Mi yahii to maayo", french: "Je suis allé(e) à la rivière", english: "I went to the river" }
  ],
  "a_yahii": [
    { original: "A yahii to lekkol", french: "Tu es allé(e) à l'école", english: "You went to school" },
    { original: "A yahii to luumo", french: "Tu es allé(e) au marché", english: "You went to the market" },
    { original: "A yahii to galle", french: "Tu es allé(e) à la maison", english: "You went home" }
  ],
  "o_yahii": [
    { original: "O yahii to galle", french: "Il/Elle est allé(e) à la maison", english: "He/She went home" },
    { original: "O yahii to lekkol", french: "Il/Elle est allé(e) à l'école", english: "He/She went to school" },
    { original: "O yahii to luumo", french: "Il/Elle est allé(e) au marché", english: "He/She went to the market" }
  ],

  // Prépositions de base
  "to": [
    { original: "Mi yahan to luumo", french: "Je vais au marché", english: "I am going to the market" },
    { original: "O yahii to galle", french: "Il/Elle est allé(e) à la maison", english: "He/She went home" },
    { original: "Min njahan to lekkol", french: "Nous allons à l'école", english: "We are going to school" }
  ],
  "e": [
    { original: "E ley suudu", french: "Dans la maison", english: "In the house" },
    { original: "E dow taabal", french: "Sur la table", english: "On the table" },
    { original: "E ley maayo", french: "Dans la rivière", english: "In the river" }
  ],
  "haa": [
    { original: "Haa janngo", french: "Jusqu'à demain", english: "Until tomorrow" },
    { original: "Haa luumo", french: "Jusqu'au marché", english: "As far as the market" },
    { original: "Haa lekkol", french: "Jusqu'à l'école", english: "As far as school" }
  ],

  // Adjectifs qualificatifs
  "moƴƴo": [
    { original: "Neɗɗo moƴƴo", french: "Une bonne personne", english: "A good person" },
    { original: "Debbo moƴƴo", french: "Une bonne femme", english: "A good woman" },
    { original: "Gorko moƴƴo", french: "Un bon homme", english: "A good man" }
  ],
  "mawɗo": [
    { original: "Suudu mawndu", french: "Une grande maison", english: "A big house" },
    { original: "Gorko mawɗo", french: "Un grand homme", english: "A big man" },
    { original: "Debbo mawɗo", french: "Une grande femme", english: "A big woman" }
  ],
  "pamaro": [
    { original: "Cukalel pamarol", french: "Un petit enfant", english: "A small child" },
    { original: "Suudu pamaaru", french: "Une petite maison", english: "A small house" },
    { original: "Lekki pamaaki", french: "Un petit arbre", english: "A small tree" }
  ],
  "bonngo": [
    { original: "Neɗɗo bonngo", french: "Une mauvaise personne", english: "A bad person" },
    { original: "Nagge bonnge", french: "Une mauvaise vache", english: "A bad cow" },
    { original: "Kuugal bonngo", french: "Un mauvais travail", english: "A bad job" }
  ]
};

export default sentencesgap;
export{};
